/**
 * Utility functions for video handling
 */

import moment from "moment";

/**
 * Extracts all videos into a flat array from the nested structure
 * @param {Array} videos - The nested videos structure from useSharedVideos
 * @returns {Array} - Flat array of all videos with date and client info
 */
export const extractAllVideos = (videos) => {
  const result = [];
  if (!videos || !Array.isArray(videos)) return result;

  videos.forEach((dateGroup) => {
    if (!dateGroup.hours) return;

    dateGroup.hours.forEach((hour) => {
      if (!hour.clients) return;

      hour.clients.forEach((client) => {
        if (!client.videos) return;

        client.videos.forEach((video) => {
          result.push({
            ...video,
            date: dateGroup.date,
            hour: hour.hour,
            clientUID: client.clientUID,
          });
        });
      });
    });
  });

  return result;
};

/**
 * Gets the most recent video from an array of videos
 * @param {Array} videos - Array of video objects
 * @returns {Object|null} - The most recent video or null
 */
export const getMostRecentVideo = (videos) => {
  if (!videos || videos.length === 0) return null;

  return videos.reduce((latest, video) => {
    return !latest.createdOn ||
      video.createdOn?.toDate() > latest.createdOn?.toDate()
      ? video
      : latest;
  }, {});
};

/**
 * Formats a timestamp into a readable date string
 * @param {Object} timestamp - Firebase timestamp object
 * @returns {String} - Formatted date string
 */
export const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return moment(date).format("MMM D, YYYY h:mm A");
};

/**
 * Gets the video type label
 * @param {Object} video - Video object
 * @returns {String} - Video type label
 */
export const getVideoTypeLabel = (video) => {
  if (video.metadata?.exercise) {
    return "Exercise Video";
  }
  return "General Video";
};
